/**
 * Patches DOM methods to ensure all dynamically created <style> tags receive the CSP nonce.
 * This is required for CSP compliance, especially for libraries like @angular/flex-layout
 * that inject styles at runtime. Must be called before any Angular or third-party code runs.
 */
export function patchNonceForDynamicStyles() {
  // Get nonce from <pin-root ngCspNonce="...">
  const root = document.querySelector("pin-root");
  const nonce = root?.getAttribute("ngCspNonce");
  if (!nonce) {
    console.warn("[CSP] No nonce found in <pin-root>");
    return;
  }

  // Patch document.createElement
  const originalCreateElement = document.createElement;
  document.createElement = function (tagName: string) {
    const element = originalCreateElement.call(this, tagName);
    if (tagName.toLowerCase() === "style") {
      element.setAttribute("nonce", nonce);
    }
    return element;
  };

  // Patch document.head.appendChild
  const originalAppendChild = document.head.appendChild.bind(document.head);
  document.head.appendChild = function (node: Node) {
    if (node.nodeName === "STYLE" && !(node as Element).hasAttribute("nonce")) {
      (node as HTMLStyleElement).setAttribute("nonce", nonce);
    }
    return originalAppendChild(node);
  };
}
